// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PlusBadge":"beb_a bho_rj bho_rk bho_vh bho_eb bho_vf bho_gs bho_kh"};